import { formatUnits, parseUnits } from "ethers";

export function parseTokenAmount(amount: string, decimals: number): bigint {
  return parseUnits(amount, decimals);
}

export function formatTokenAmount(amount: bigint, decimals: number): string {
  return formatUnits(amount, decimals);
}

export function addApprovalBuffer(amount: bigint, basisPoints = 10n): bigint {
  return amount + (amount * basisPoints) / 10_000n;
}
